import {safeFileName} from './section-export.js';

function timestampedFileName(title,extension,now){
 const pad=value=>String(value).padStart(2,'0');
 const weekday=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][now.getDay()];
 const date=`${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}`;
 const clock=`${pad(now.getHours())}-${pad(now.getMinutes())}`;
 return `${safeFileName(title)} - ${date} ${weekday} ${clock}.${extension}`;
}

export const backupFileName=(title,now=new Date())=>timestampedFileName(title,'json',now);
export const pdfFileName=(title,now=new Date())=>timestampedFileName(title,'pdf',now);
